export default __webpack_public_path__ + "media/images/avatars/avatar2-b1dc5ead449f19aa736a70f02980f8f8.png";